import cn from "classnames";
import styles from "./CTABlock.module.scss";
import { Heading } from "components/UI/typography/Heading";
import { Button } from "components/UI/buttons/Button";
import { ReactNode } from "react";
import { baseUrl } from "@/const";

type CTABlockProps = {
  heading: ReactNode;
  subheading: string;
  btnLink?: string;
  btnText: string;
  className?: string;
};

export const CTABlock = ({
  heading,
  subheading,
  btnLink = "/order",
  btnText,
  className = "",
}: CTABlockProps) => {
  return (
    <a href={`https://app.${String(baseUrl) + btnLink}`} className={cn(styles.CTABlock, className)}>
      <div className={styles.inner}>
        <Heading level={3} tag={0} className={styles.heading}>
          {heading}
        </Heading>
        <p className={styles.paragraph}>{subheading}</p>
      </div>

      <Button tag="span" type="accent" className={styles.btn}>
        {btnText}
      </Button>
    </a>
  );
};
